;(function ($, window, document) {
  function isSearchOpen() {
    const searchOpen =
      $('#navigation-search') &&
      $('#navigation-search').hasClass('has-results') &&
      $('#navigation-search').hasClass('open')
    return searchOpen
  }
  //
  // Initialization
  // --------------
  function onDOMContentLoaded() {
    // Extend default Bootstrap collapse functionality by showing only one
    // collapsible navigation at a time. BS has this functionality baked in
    // (accordion) but it interestingly is dependent on .panel CSS class and
    // certain markup, therefore is a no go.
    //
    // @see: http://getbootstrap.com/javascript/#collapse-options
    const $primaryNavContainer = $('#js-primary-nav-container'),
      $primaryNav = $primaryNavContainer.find('.collapse')

    if (!$primaryNav) {
      return
    }
    if ($primaryNav.collapse) {
      $primaryNav.collapse({ toggle: false })
    }

    // Deactivate all other primary navigations and toggles
    if ($primaryNav.on && $primaryNav.not) {
      $primaryNav.on('show.bs.collapse', function () {
        $primaryNav.not($(this)).collapse('hide')

        // Make page unscrollable if mobile nav is opened -- nav scrolling is allowed
        if ($primaryNavContainer.width() < 768) {
          $('html body').addClass('no-scroll')
        }
      })
      $primaryNav.on('hidden.bs.collapse', function () {
        if ($primaryNavContainer.width() < 768) {
          if (!isSearchOpen()) {
            $('html body').removeClass('no-scroll')
          }
        }
      })
    }

    // handle screen resizes
    const width = $(window).width()
    $(window).on('resize', function () {
      if ($(this).width() != width) {
        if ($primaryNavContainer.width() >= 768) {
          if (!isSearchOpen()) {
            $('html body').removeClass('no-scroll')
          }
        }
        if (
          $primaryNavContainer.width() <= 767 &&
          !$('html body').hasClass('no-scroll') &&
          $primaryNav.is('.collapse.in')
        ) {
          $('html body').addClass('no-scroll')
        }
      }
    })
  }
  if (document.readyState == 'loading') {
    document.addEventListener('DOMContentLoaded', onDOMContentLoaded)
  } else {
    onDOMContentLoaded()
  }
})(jQuery, window, document)
